/**
 * Single shared Stripe instance. loadStripe() is only called once so we don't
 * trigger duplicate script/API requests when both Signup and Checkout are
 * imported at app load.
 */
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from './config';

export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
